import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { wacToken } from "@/libraries/design/foundations";

import {
    NasaLogo,
    AirCanadaLogo,
    VisaLogo,
    CanvaLogo,
    DominosLogo,
    FordLogo
} from "./assets";

const svgArray = [
    NasaLogo,
    AirCanadaLogo,
    VisaLogo,
    CanvaLogo,
    DominosLogo,
    FordLogo
];

export const LogoBanner = () => {
    return (
        <div css={logoBannerStyles}>
            <ul css={logoContainerStyles}>
                {svgArray.map((Component, idx) => (
                    <li key={idx} id={`item-${idx}`} css={logoStyles}>
                        <Component />
                    </li>
                ))}
            </ul>
        </div>
    );
};

LogoBanner.displayName = "LogoBanner";

const logoBannerStyles = css({
    // eslint-disable-next-line local/ensure-wac-token-usage
    background: "#F4F5F7",
    clipPath: "polygon(0 0, 100% 0, 100% 87%, 0 100%)",
    [media.below.lg]: {
        clipPath: "polygon(0 0, 100% 0, 100% 92%, 0 100%)"
    }
});

const logoContainerStyles = css({
    listStyle: "none",
    padding: "80px 0px",
    opacity: "0.7",
    maxWidth: "1525px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    [media.below.lg]: {
        padding: "30px 0px",
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        justifyItems: "center",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["#item-0"]: {
            gridArea: "nasa-logo"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["#item-1"]: {
            gridArea: "air-canada-logo"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["#item-2"]: {
            gridArea: "visa-logo"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["#item-3"]: {
            gridArea: "canva-logo"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["#item-4"]: {
            gridArea: "dominos-logo",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ["svg"]: {
                maxWidth: "100px"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["#item-5"]: {
            gridArea: "ford-logo",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ["svg"]: {
                maxWidth: "80px"
            }
        },
        gridTemplateAreas:
            '"nasa-logo air-canada-logo canva-logo" "dominos-logo ford-logo visa-logo"'
    }
});

const logoStyles = css({
    color: wacToken("color.neutral.light800"),
    margin: 0,
    padding: 0,
    [media.below.lg]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["svg"]: {
            maxHeight: "40px",
            maxWidth: "120px"
        }
    }
});
